var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtChat3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451,243.89H330.64s11.94-32.6,30.31-32.6,24.12,22.5,24.12,22.5,12.4-12.22,22.58-12.22,19,16.15,19,16.15S441.07,229,451,243.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,74.23H251.79S264.36,56,274.27,56,287.1,68.16,287.1,68.16s7-5.66,13.46-4.65S308.05,74.23,308.05,74.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,112.27H358.73S371.3,94.05,381.2,94.05,394,106.2,394,106.2s7-5.67,13.46-4.66S415,112.27,415,112.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84,203.29H279.58s12.57-18.22,22.47-18.22,12.83,12.15,12.83,12.15,7-5.67,13.47-4.66S335.84,203.29,335.84,203.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,242.16H49S61.54,224,71.44,224s12.84,12.14,12.84,12.14,7-5.67,13.46-4.65S105.23,242.16,105.23,242.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91,129.27H70.32s15-33.5,31.06-35.6,23.73,24.9,23.73,24.9,10.36-9.54,18.5-9.54S158,121.59,158,121.59,174.32,113,179.91,129.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.07,
    y: 268.6,
    width: 33.16,
    height: 173.85,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 274.25,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 274.25,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 285.51,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 285.51,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 296.78,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 296.78,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 308.05,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 308.05,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 319.32,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 319.32,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 330.59,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 330.59,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 341.86,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 341.86,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 353.13,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 353.13,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 364.4,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 364.4,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 375.67,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 375.67,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 386.94,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 386.94,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 398.21,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 398.21,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 409.48,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 409.48,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.21,
    y: 420.75,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 420.75,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 848.14) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 409.48,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 825.6) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 398.21,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 803.06) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 386.94,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 780.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 375.67,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 757.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 364.4,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 735.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 353.13,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 712.91) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 341.86,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 690.37) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 330.59,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 667.83) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 319.32,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 645.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 308.05,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 622.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 296.78,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 600.21) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 285.51,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 577.67) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.64,
    y: 274.25,
    width: 6.45,
    height: 6.64,
    transform: "translate(725.72 555.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.46,
    y: 420.75,
    width: 6.45,
    height: 6.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.23,
    y: 268.6,
    width: 26.15,
    height: 173.85,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 420.75,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 848.14) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 420.75,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 848.14) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 409.48,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 825.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 409.48,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 825.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 398.21,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 803.06) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 398.21,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 803.06) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 386.94,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 780.52) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 386.94,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 780.52) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 375.67,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 757.98) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 375.67,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 757.98) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 364.4,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 735.45) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 364.4,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 735.45) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 353.13,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 712.91) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 353.13,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 712.91) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 341.86,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 690.37) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 341.86,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 690.37) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 330.59,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 667.83) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 330.59,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 667.83) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 319.32,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 645.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 319.32,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 645.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 308.05,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 622.75) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 308.05,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 622.75) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 296.78,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 600.21) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 296.78,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 600.21) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 285.51,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 577.67) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 285.51,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 577.67) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.36,
    y: 274.25,
    width: 5.32,
    height: 6.64,
    transform: "translate(784.04 555.13) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 274.25,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 285.51,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 296.78,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 308.05,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 319.32,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 330.59,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 341.86,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 353.13,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 364.4,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 375.67,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 386.94,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 398.21,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 409.48,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.8,
    y: 420.75,
    width: 5.32,
    height: 6.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 274.25,
    width: 5.32,
    height: 6.64,
    transform: "translate(770.42 555.13) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.53,
    y: 259.22,
    width: 39.23,
    height: 183.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.58,
    y: 255.21,
    width: 40.18,
    height: 4.01,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 265.14,
    width: 3.97,
    height: 177.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 265.14,
    width: 3.97,
    height: 177.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 265.14,
    width: 3.97,
    height: 177.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 265.14,
    width: 3.98,
    height: 177.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 265.14,
    width: 3.97,
    height: 177.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 270.21,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 270.21,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 270.21,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 270.21,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 270.21,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 283.07,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 283.07,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 283.07,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 283.07,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 283.07,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 295.94,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 295.94,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 295.94,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 295.94,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 295.94,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 308.81,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 308.81,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 308.81,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 308.81,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 308.81,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 321.68,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 321.68,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 321.68,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 321.68,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 321.68,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 334.55,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 334.55,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 334.55,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 334.55,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 334.55,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 347.42,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 347.42,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 347.42,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 347.42,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 347.42,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 360.29,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 360.29,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 360.29,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 360.29,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 360.29,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 373.16,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 373.16,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 373.16,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 373.16,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 373.16,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 386.03,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 386.03,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 386.03,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 386.03,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 386.03,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 398.9,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 398.9,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 398.9,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 398.9,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 398.9,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 411.77,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 411.77,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 411.77,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 411.77,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 411.77,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 424.64,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 424.64,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 424.64,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 424.64,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 424.64,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.07,
    y: 437.51,
    width: 3.97,
    height: 4.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 437.51,
    width: 3.97,
    height: 4.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.16,
    y: 437.51,
    width: 3.97,
    height: 4.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 437.51,
    width: 3.98,
    height: 4.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.24,
    y: 437.51,
    width: 3.97,
    height: 4.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.76,
    y: 259.22,
    width: 25.19,
    height: 183.22,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.76,
    y: 255.21,
    width: 26.28,
    height: 4.01,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 265.14,
    width: 3.98,
    height: 177.31,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 265.14,
    width: 3.97,
    height: 177.31,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 265.14,
    width: 3.97,
    height: 177.31,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 270.21,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 270.21,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 270.21,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 283.07,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 283.07,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 283.07,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 295.94,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 295.94,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 295.94,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 308.81,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 308.81,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 308.81,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 321.68,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 321.68,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 321.68,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 334.55,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 334.55,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 334.55,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 347.42,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 347.42,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 347.42,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 360.29,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 360.29,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 360.29,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 373.16,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 373.16,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 373.16,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 386.03,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 386.03,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 386.03,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 398.9,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 398.9,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 398.9,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 411.77,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 411.77,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 411.77,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 424.64,
    width: 3.98,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 424.64,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 424.64,
    width: 3.97,
    height: 7.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.31,
    y: 437.51,
    width: 3.98,
    height: 4.94,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.35,
    y: 437.51,
    width: 3.97,
    height: 4.94,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.39,
    y: 437.51,
    width: 3.97,
    height: 4.94,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.27,
    y: 326.56,
    width: 39.07,
    height: 115.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.83,
    y: 316.73,
    width: 33.51,
    height: 9.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 331.69,
    width: 30.5,
    height: 110.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 342.26,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 353.1,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 363.94,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 374.78,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 385.62,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 396.46,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 407.3,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 418.14,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 428.99,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.56,
    y: 439.83,
    width: 30.5,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.34,
    y: 326.56,
    width: 24.47,
    height: 115.89,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.34,
    y: 316.73,
    width: 20.8,
    height: 9.83,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 331.69,
    width: 18.81,
    height: 110.76,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 342.26,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 353.1,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 363.94,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 374.78,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 385.62,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 396.46,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 407.3,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 418.14,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 428.99,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 439.83,
    width: 18.81,
    height: 2.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.63,
    y: 374.6,
    width: 30.2,
    height: 67.84,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 380.47,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 389.35,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 398.23,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 407.11,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 415.99,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 424.86,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.38,
    y: 433.74,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 380.47,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 389.35,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 398.23,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 407.11,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 415.99,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 424.86,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 433.74,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 380.47,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 389.35,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 398.23,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 407.11,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 415.99,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 424.86,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.74,
    y: 433.74,
    width: 5.34,
    height: 4.16,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.83,
    y: 374.6,
    width: 21.19,
    height: 67.84,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 433.08,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 870.31) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 424.2,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 852.56) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 415.32,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 834.8) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 406.44,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 817.05) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 397.57,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 799.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 388.69,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 781.53) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 379.81,
    width: 4.35,
    height: 4.16,
    transform: "translate(425.35 763.78) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 433.08,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 870.31) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 424.2,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 852.56) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 415.32,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 834.8) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 406.44,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 817.05) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 397.57,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 799.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 388.69,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 781.53) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.24,
    y: 379.81,
    width: 4.35,
    height: 4.16,
    transform: "translate(412.83 763.78) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 433.08,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 870.31) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 424.2,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 852.56) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 415.32,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 834.8) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 406.44,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 817.05) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 397.57,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 799.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 388.69,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 781.53) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 379.81,
    width: 4.35,
    height: 4.16,
    transform: "translate(400.35 763.78) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.65,
    y: 296.78,
    width: 20.86,
    height: 24.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.52,
    y: 296.78,
    width: 13.23,
    height: 25.55,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.5,
    y: 307.67,
    width: 13.13,
    height: 14.67,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.63,
    y: 307.67,
    width: 8.19,
    height: 14.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.65,
    y: 319.83,
    width: 33.74,
    height: 122.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 325.1,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 325.1,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 332.46,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 332.46,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 339.82,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 339.82,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 347.18,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 347.18,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 354.54,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 354.54,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 361.9,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 361.9,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 369.26,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 369.26,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 376.62,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 376.62,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 383.98,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 383.98,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 391.34,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 391.34,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 398.7,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 398.7,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 406.06,
    width: 10.61,
    height: 4.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 406.06,
    width: 10.61,
    height: 4.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 413.42,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 413.42,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 420.78,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.08,
    y: 420.78,
    width: 10.61,
    height: 4.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.39,
    y: 319.83,
    width: 27.34,
    height: 122.61,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 420.78,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 845.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 420.78,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 845.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 413.42,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 831.17) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 413.42,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 831.17) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 406.06,
    width: 8.71,
    height: 4.34,
    transform: "translate(891.26 816.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 406.06,
    width: 8.71,
    height: 4.34,
    transform: "translate(868.97 816.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 398.7,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 801.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 398.7,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 801.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 391.34,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 787.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 391.34,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 787.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 383.98,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 772.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 383.98,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 772.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 376.62,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 757.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 376.62,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 757.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 369.26,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 742.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 369.26,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 742.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 361.9,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 728.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 361.9,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 728.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 354.54,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 713.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 354.54,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 713.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 347.18,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 698.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 347.18,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 698.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 339.82,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 683.97) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 339.82,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 683.97) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 332.46,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 669.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 332.46,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 669.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.27,
    y: 325.1,
    width: 8.71,
    height: 4.33,
    transform: "translate(891.26 654.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.13,
    y: 325.1,
    width: 8.71,
    height: 4.33,
    transform: "translate(868.97 654.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.85,
    y: 362.55,
    width: 39.79,
    height: 79.9,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 369.46,
    width: 7.04,
    height: 4.89,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 379.92,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 390.37,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 400.83,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 411.28,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 421.74,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 432.19,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 369.46,
    width: 7.04,
    height: 4.89,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 379.92,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 390.37,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 400.83,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 411.28,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 421.74,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.24,
    y: 432.19,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 369.46,
    width: 7.04,
    height: 4.89,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 379.92,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 390.37,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 400.83,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 411.28,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 421.74,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 432.19,
    width: 7.04,
    height: 4.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.15,
    y: 354.22,
    width: 26.49,
    height: 8.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.85,
    y: 349.07,
    width: 16.8,
    height: 5.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.64,
    y: 362.55,
    width: 27.92,
    height: 79.9,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 431.41,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 867.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 420.96,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 846.81) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 410.5,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 825.9) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 400.05,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 804.99) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 389.59,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 784.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 379.14,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 763.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.97,
    y: 368.68,
    width: 5.73,
    height: 4.9,
    transform: "translate(609.68 742.26) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 431.41,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 867.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 420.96,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 846.81) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 410.5,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 825.9) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 400.05,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 804.99) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 389.59,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 784.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 379.14,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 763.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.73,
    y: 368.68,
    width: 5.73,
    height: 4.9,
    transform: "translate(593.19 742.26) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 431.41,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 867.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 420.96,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 846.81) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 410.5,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 825.9) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 400.05,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 804.99) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 389.59,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 784.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 379.14,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 763.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 368.68,
    width: 5.73,
    height: 4.9,
    transform: "translate(576.74 742.26) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.64,
    y: 354.22,
    width: 23.69,
    height: 8.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.64,
    y: 349.07,
    width: 12.84,
    height: 5.15,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-154"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "459.98 448.79 407.49 449.03 354.99 449.12 250 449.29 145.01 449.12 92.52 449.03 40.02 448.79 92.52 448.54 145.01 448.46 250 448.29 354.99 448.46 407.49 448.55 459.98 448.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.02,
    y: 442.44,
    width: 419.96,
    height: 6.09,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.46,442.44a8.56,8.56,0,0,1,.5,3.05,8.29,8.29,0,0,1-.5,3,9.52,9.52,0,0,1,0-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,442.44a9.52,9.52,0,0,1,0,6.09,8.29,8.29,0,0,1-.5-3A8.56,8.56,0,0,1,102.29,442.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.11,442.44a8.56,8.56,0,0,1,.5,3.05,8.29,8.29,0,0,1-.5,3,9.52,9.52,0,0,1,0-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.94,442.44a9.52,9.52,0,0,1,0,6.09,8.29,8.29,0,0,1-.5-3A8.56,8.56,0,0,1,167.94,442.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.76,442.44a8.56,8.56,0,0,1,.5,3.05,8.29,8.29,0,0,1-.5,3,9.52,9.52,0,0,1,0-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,442.44a9.52,9.52,0,0,1,0,6.09,8.29,8.29,0,0,1-.5-3A8.56,8.56,0,0,1,233.59,442.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41,442.44a8.56,8.56,0,0,1,.5,3.05,8.29,8.29,0,0,1-.5,3,9.52,9.52,0,0,1,0-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.24,442.44a9.52,9.52,0,0,1,0,6.09,8.29,8.29,0,0,1-.5-3A8.56,8.56,0,0,1,299.24,442.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.06,442.44a8.56,8.56,0,0,1,.5,3.05,8.29,8.29,0,0,1-.5,3,9.52,9.52,0,0,1,0-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,442.44a9.52,9.52,0,0,1,0,6.09,8.29,8.29,0,0,1-.5-3A8.56,8.56,0,0,1,364.89,442.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.71,442.44a8.56,8.56,0,0,1,.5,3.05,8.29,8.29,0,0,1-.5,3,9.52,9.52,0,0,1,0-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.54,442.44a9.52,9.52,0,0,1,0,6.09,8.29,8.29,0,0,1-.5-3A8.56,8.56,0,0,1,430.54,442.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.25,59.17l-.24-.71c.63-.22,1.27-.42,1.91-.62l.22.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.45,140l-.16-.74c1.32-.27,2.63-.6,3.9-1l.2.72C292.11,139.39,290.78,139.72,289.45,140Zm8.75-2.61-.27-.7c1.23-.48,2.47-1,3.67-1.6l.32.68C300.7,136.36,299.45,136.9,298.2,137.39Zm8.19-4-.39-.64c1.13-.68,2.26-1.42,3.36-2.19l.43.61C308.67,131.92,307.53,132.66,306.39,133.35Zm7.43-5.3-.48-.58c1-.83,2-1.73,3-2.66l.51.55C315.86,126.3,314.84,127.2,313.82,128.05Zm6.67-6.26-.55-.52c.9-.93,1.81-1.93,2.73-3l.56.5C322.31,119.84,321.39,120.85,320.49,121.79Zm6-6.86-.58-.48c.85-1,1.68-2.09,2.51-3.16l.59.46Q327.78,113.35,326.5,114.93Zm5.58-7.22-.6-.44,2.4-3.26.6.44Zm5.37-7.36-.61-.44,2.39-3.28.6.44ZM342.83,93l-.6-.45c.81-1.08,1.63-2.16,2.46-3.23l.59.46C344.45,90.85,343.64,91.92,342.83,93Zm5.59-7.17-.58-.48c.86-1,1.73-2.08,2.62-3.1l.56.49C350.14,83.76,349.27,84.79,348.42,85.83Zm6-6.83-.55-.51c.95-1,1.91-2,2.85-2.9l.53.54C356.3,77,355.34,78,354.41,79Zm6.53-6.28-.49-.57c1-.9,2.09-1.77,3.13-2.58l.47.59C363,71,362,71.82,360.94,72.72Zm7.17-5.52-.42-.62c1.12-.76,2.27-1.5,3.42-2.18l.39.64C370.36,65.72,369.22,66.45,368.11,67.2Zm7.79-4.56-.33-.67c1.2-.6,2.45-1.17,3.69-1.7l.29.69C378.32,61.48,377.1,62.05,375.9,62.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.35,141.06l-.07-.75q1-.09,2-.21l.09.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.69 45.52 386.03 58.2 398.07 52.1 440.82 45.49 393.69 45.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.69 45.52 386.03 58.2 398.07 52.1 440.82 45.49 393.69 45.52",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.79 55.55 386.03 58.2 398.07 52.1 398.79 55.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.07 52.1 440.82 45.49 401.8 70.98 398.07 52.1",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.69 45.52 379.22 31.55 440.82 45.49 393.69 45.52",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-154"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.45,
    y: 152.8,
    width: 12.89,
    height: 289.65,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.34,
    y: 152.8,
    width: 6.99,
    height: 289.65,
    transform: "translate(317.68 595.24) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.26,
    y: 149.15,
    width: 14.08,
    height: 3.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.34,
    y: 149.15,
    width: 8.21,
    height: 3.64,
    transform: "translate(318.89 301.95) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.1,
    y: 145.93,
    width: 11.24,
    height: 3.23,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.34,
    y: 145.93,
    width: 5.62,
    height: 3.23,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,138.66a7.27,7.27,0,1,1-7.27-7.28A7.27,7.27,0,0,1,159.85,138.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.92,177.84v31H66.51V178.13A16.42,16.42,0,0,1,82.93,161.7h.85A16.14,16.14,0,0,1,99.92,177.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.58,175.32v33.55H99.92v-31A16.14,16.14,0,0,0,83.78,161.7H139A13.62,13.62,0,0,1,152.58,175.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.58,175.32v33.55H99.92v-31A16.14,16.14,0,0,0,83.78,161.7H139A13.62,13.62,0,0,1,152.58,175.32Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06,177.24v31.63h-2.15v-31A16.14,16.14,0,0,0,90.78,161.7h2.74A15.54,15.54,0,0,1,109.06,177.24Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.69,177.24v31.63h-2.15v-31a16.14,16.14,0,0,0-16.13-16.14h2.74A15.54,15.54,0,0,1,147.69,177.24Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.75,200.55v-5l-1.81,3.64h-1l-1.81-3.64v5h-1.94v-8.36h2.1l2.17,4.36,2.17-4.36h2.09v8.36Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55,192.19h1.75l3,8.36h-2l-.65-1.88h-2.6l-.64,1.88h-2Zm1.85,5.15-1-3-1,3Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.17,200.55v-8.36h1.93v8.36Z",
    style: {
      fill: "#020100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7,200.55v-8.36h1.93v6.66h4.05v1.7Z",
    style: {
      fill: "#020100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,178.6v27.86h-30v-27.6A14.75,14.75,0,0,1,83,164.11h.76A14.49,14.49,0,0,1,98.21,178.6Z",
    style: {
      fill: "#020100",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,212l3.71-3.1H99.92l-3.36,2.81c-10.81,9.07-25.6,16.43-34.67,16.43H59.71C50.8,228.11,49.51,222.23,62.8,212Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.91,208.87l-3.35,2.81c-10.81,9.07-25.6,16.43-34.67,16.43H59.52c-8.74-.09-9.92-6,3.28-16.14l3.7-3.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,208.87l-3.35,2.81c-10.77,9-25.49,16.37-34.57,16.43-8.74-.09-9.92-6,3.28-16.14l3.7-3.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.41 222.63 147.41 231.16 129.68 208.87 136.47 208.87 147.41 222.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.41 231.16 144.91 231.16 127.18 208.87 129.69 208.87 147.41 231.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,147.27v7.9h-7.23v29.67a2.5,2.5,0,0,1-2.5,2.5h0a2.5,2.5,0,0,1-2.5-2.5V145.29l5,.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,147.27v7.9h-7.23v29.67a2.5,2.5,0,0,1-2,2.44h0a2.24,2.24,0,0,1-.52.06,1.87,1.87,0,0,1-.42,0,2.41,2.41,0,0,1-1.35-.69,2.52,2.52,0,0,1-.73-1.77V145.29l5,.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.24,187.34h-1.95a2.13,2.13,0,0,1-2.15-2V145.29h1.6v39.55a2.52,2.52,0,0,0,.73,1.77A2.92,2.92,0,0,0,110.24,187.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,178.6v19.59l-5-2.09-2.92-1.23L89,194.33l-.84-.36,0,0-.89-.37-.27-.11-.35-.15-7.34-3.1,1.55-3.69.3-.7,1.33-3.14.53-1.28.22-.5.92-2.2,1-2.48,4-9.56,5.24,2.21a14.32,14.32,0,0,1,3.25,6A14.48,14.48,0,0,1,98.21,178.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,183.7v2.18l-.12-.25,0-.11-.09-.19a1.74,1.74,0,0,1-.1-.19l-1.19-2.45c0-.1-.1-.2-.15-.31l-1.05-2.2c-.22-.44-.43-.88-.64-1.33l-.06-.14-1.59-3.35c-.39-.85-.79-1.7-1.18-2.56-.92-2-1.87-4.06-2.76-6.13,1.08,1.91,2.09,3.85,3.14,5.78.5,1,1,1.89,1.5,2.84l1.58,3,.21.41.67,1.3.82,1.61c0,.08.09.16.13.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,185.5v.09l-.12,0-.3.09c-1.27.39-2.54.74-3.82,1.07l-.42.1-.93.23-.11,0-1.1.26-2.15.48c-1.52.32-3,.62-4.57.88l-.18,0-.93.15c-1.29.22-2.58.4-3.88.54,1.12-.37,2.24-.69,3.37-1l1-.26.31-.09c1.56-.4,3.14-.75,4.71-1.1l1.41-.3c.42-.07.83-.16,1.25-.24s1-.2,1.52-.28l.58-.1.32-.06c1.16-.2,2.33-.38,3.52-.52l.36,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.34,
    y: 180.54,
    width: 25.88,
    height: 25.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,192.34v1.25l-.24.21-.46.41a2,2,0,0,0-.16.14l-.14.13-.1.09-3.87,3.36-.53.45-.23.19-.23-.19-1.94-1.69-1-.83c-.2-.18-.41-.35-.61-.54a.53.53,0,0,1-.14-.12l-.7-.6,0,0-.09-.08-.16-.14-.16-.13q-2-1.69-3.88-3.42l-.52-.46-.83-.74-1.38-1.23c-1-.86-1.93-1.73-2.88-2.61l-.34-.3-.37-.33c-1.64-1.53-3.3-3-4.92-4.58,1.73,1.33,3.43,2.74,5.14,4.1.13.11.27.21.4.33l.43.35,2.84,2.33,1.44,1.19,1.47,1.23.63.53q1.78,1.49,3.55,3h0l.26.22.69.59.31.26.58.5,2.39,2c1.4-1.2,2.81-2.41,4.22-3.6h0l.42-.36c.27-.23.53-.46.81-.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31,194.18l0,0-.64.54c-1,.85-2,1.67-3.1,2.46-1.28,1-2.59,1.92-3.91,2.85s-2.66,1.82-4,2.69-2.74,1.73-4.16,2.51c1.22-1.07,2.5-2.07,3.78-3.05s2.6-1.92,3.91-2.85,2.67-1.83,4-2.7c1.08-.69,2.18-1.38,3.31-2l.79-.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,195.07v.42l-.86-.72-.24-.2-.4-.34s0,0,0,0l.07,0,.48.27.3.18Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.89,335s-31.7,26.87-31.73,26.88c-6.09,5.11-11.34,9.7-13.83,12.32,0,0,0,0,0,0a5.56,5.56,0,0,0-1.5,2s0,.05,0,.07c.29,2.84,39.68,52.7,41.64,54s5.75-4.2,5.76-7.36-6.53-29-6.53-29l31.43-27.16Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.67,356.35s-6.48,5.5-6.51,5.51c-6.09,5.11-11.34,9.7-13.83,12.32,0,0,0,0,0,0a10.58,10.58,0,0,0-1.5,2s0,.05,0,.07c.29,2.84,39.68,52.7,41.64,54s5.75-4.2,5.76-7.36-6.53-29-6.53-29l6.68-5.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,430.29c-2-1.27-41.35-51.13-41.64-54-.13-1.09,6.8-7.25,15.38-14.45l.28-.23,25.76,31.88-.55.42s6.54,25.83,6.53,29S186.37,431.58,184.42,430.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.9,428.2c-6.43-8.56-33.18-42.51-40.19-50.49-.06-.06-.11,0-.05,0,6.19,8.63,33.21,42.36,40.11,50.56C185.91,428.48,186,428.38,185.9,428.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.69,396.72c-2-3.79-5.7-7.44-10.05-8.1-.17,0-.21.21-.09.29a59.4,59.4,0,0,1,9.71,8.13A.27.27,0,0,0,185.69,396.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.13,400.24c-2-3.79-5.7-7.43-10-8.1-.17,0-.2.21-.08.29a59.32,59.32,0,0,1,9.7,8.13A.27.27,0,0,0,186.13,400.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,403.77c-2-3.8-5.7-7.44-10.05-8.11-.17,0-.2.22-.08.3a59.26,59.26,0,0,1,9.7,8.12A.27.27,0,0,0,186.58,403.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.64,303.45c-2,11.36-47.88,57.57-47.88,57.57l33.58,37s65-68,61-92.92c-3.53-21.66-38.1-108.28-38.1-108.28l-37.53.88S208.63,292.28,206.64,303.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.85,388.94c-4.47-5.31-3.11-3.85-7.64-9.11-2.22-2.57-16.8-19.46-19.29-21.5-.06,0-.15,0-.11.1,1.7,2.73,16.58,19.36,18.84,21.89,4.63,5.17,3.36,3.64,8,8.75A.1.1,0,1,0,195.85,388.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,299.58c-.6-2.81-1.28-5.61-1.94-8.4q-2-8.56-4.27-17.08-4.46-16.89-9.61-33.57c-3.46-11.15-7.1-22.29-11.25-33.21-.52-1.35-1.05-2.69-1.57-4a.09.09,0,0,0-.17.06c3.63,10.95,7.37,21.87,10.79,32.89s6.58,22,9.59,33.11c1.51,5.57,2.92,11.16,4.31,16.76q1,4.13,2,8.27a59.12,59.12,0,0,1,1.77,8.52,13.05,13.05,0,0,1-2,7.77c-1.35,2.33-3,4.54-4.5,6.74-3.11,4.43-32.86,39.18-33.82,40.12-.08.08,0,.19.12.11,4-3.77,29.28-32.43,32.47-36.85,1.57-2.18,3.11-4.4,4.62-6.63a25.94,25.94,0,0,0,3.57-6.66A15.48,15.48,0,0,0,213,299.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,197l-1.41,99.53c-4.22-24.84-28.4-98.83-28.4-98.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.94,381.43s9,39.26,9,39.28c.29,8,.69,14.9,1.24,18.48a.13.13,0,0,0,0,.06,5.53,5.53,0,0,0,.67,2.43l.05.05c2.42,1.52,66,1,68.17.26s.21-7.13-2.27-9.07-26.9-12.64-26.9-12.64l-9.42-39.23Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,442c-2.21.77-65.75,1.27-68.17-.25l-.05-.05a5.34,5.34,0,0,1-.67-2.43.07.07,0,0,1,0-.06c-.54-3.58-.93-10.53-1.23-18.47,0,0-1.56-6.84-1.56-6.84l40.76-.95,1.76,7.34s24.41,10.7,26.91,12.65S278.32,441.23,276.1,442Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,442c-2.21.76-65.74,1.26-68.17-.26-.94-.56-1.55-9.81-2-21,0-.11,0-.23,0-.35l41-.77v.69s24.4,10.69,26.9,12.64S278.31,441.23,276.1,442Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.36,439.53c-10.71-.18-53.93.11-64.53.74-.09,0-.09.07,0,.07,10.61.41,53.83-.23,64.53-.63C275.59,439.7,275.59,439.53,275.36,439.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37,420.38c-4.22-.76-9.37-.07-12.56,3-.13.12,0,.29.18.25a58.58,58.58,0,0,1,12.37-2.68A.27.27,0,0,0,250.37,420.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,422.19c-4.22-.76-9.37-.07-12.57,3-.12.12,0,.29.18.25a58.8,58.8,0,0,1,12.38-2.68A.27.27,0,0,0,253.43,422.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.48,424c-4.22-.76-9.37-.07-12.56,3-.13.12,0,.29.18.25a58.71,58.71,0,0,1,12.37-2.68A.27.27,0,0,0,256.48,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,196.89c0,.79-3.05,33-4.07,33.91s-7.66,5.57-9.63,6.84c0,0,19.3,55.62,24.5,74.19,7.55,26.93,26,107.81,26,107.81l-44.15,1s-15.23-77.05-21.7-102.7c-5.54-22-26.36-87.87-26.36-87.87a57,57,0,0,1,.81-31.93S211.62,196.86,211.61,196.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.63,411.09c-6.94.12-4.95,0-11.89.19-3.39.1-25.7.77-28.85,1.42-.07,0-.06.13,0,.14,3.19.4,25.48-.66,28.87-.82,6.93-.34,4.94-.32,11.87-.73A.1.1,0,0,0,246.63,411.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,229.13a84,84,0,0,0-12,8.44.15.15,0,0,0,.17.25c4.06-2.69,8.23-5.3,12.15-8.2A.3.3,0,0,0,209.46,229.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,198.71c0-.15-.31-.13-.28,0A148.88,148.88,0,0,1,207,213.6c.2,2.3.62,15.17-3.47,15-.69,0-1.14-.62-1.43-1.59a16.19,16.19,0,0,1-.16-3.94c0-2.71-.16-5.4-.41-8.1a72.53,72.53,0,0,0-2.82-14.81.13.13,0,0,0-.25.06,137.43,137.43,0,0,1,2.47,20.7c.1,3.35-.67,8.56,2.84,8.45s4.34-8.74,4.36-11.07A76.12,76.12,0,0,0,205.37,198.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68,228.88a23.58,23.58,0,0,0-.42,2.76,5.86,5.86,0,0,0,0,2.21c0,.13.22.11.28,0a7.35,7.35,0,0,0,.54-2.24c.16-.86.33-1.71.46-2.57A.45.45,0,0,0,203.68,228.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.38,387.88c-.14-1-.3-2-.47-3.05-.32-1.95-.7-3.89-1-5.84-.7-3.91-1.46-7.81-2.25-11.7-1.57-7.76-3.35-15.5-5.21-23.19-1.06-4.35-2.27-8.65-3.54-12.94-.09-.3-.51-.14-.45.15.8,3.93,1.58,7.87,2.48,11.79s1.79,7.81,2.67,11.72c1.72,7.73,3.34,15.49,5.05,23.22.49,2.18.93,4.37,1.41,6.55q.36,1.64.75,3.27c.26,1.08.62,2.14.83,3.23,0,.1.17.05.15,0C198.57,390,198.53,388.93,198.38,387.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.45,328.51c-1.64-7.29-3.79-14.47-5.95-21.62-4.35-14.39-9.41-28.56-14.45-42.72l-4.36-12.24c-.73-2-4.32-13.05-4.75-14.09a.09.09,0,1,0-.17.06c1,3.75,2.48,9.22,3.66,12.94s2.45,7.3,3.69,11c2.42,7.17,4.88,14.33,7.24,21.53,4.66,14.22,9.29,28.44,13.15,42.91,1.07,4.05,2.15,8.1,3.14,12.18s1.86,8.16,2.81,12.24c0,.11.21.07.2,0A224.91,224.91,0,0,0,227.45,328.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9,367.47c-2.75-13.92-6-27.75-9.54-41.48s-7.49-27.52-11.79-41.11-9-27.05-14.06-40.39a171.92,171.92,0,0,1-6.45-19.21c-1.6-6.5-2.51-13.54-1.14-20.16a33.9,33.9,0,0,1,1.4-4.94c0-.11-.13-.2-.17-.09-5,12.5-1.26,25.95,3.07,38,2.37,6.63,4.88,13.21,7.22,19.85q3.62,10.22,6.93,20.54c4.4,13.64,8.5,27.36,12.21,41.2s7.06,27.76,10,41.77,5.57,28.18,8.17,42.31c.34,1.84.62,3.69.9,5.54,0,.1.18.1.17,0C205.83,395.33,203.65,381.37,200.9,367.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,139.71c4.57,16.88,15.3,43,24.24,42.68,8.15-.32,26-15.21,33.53-20.13s-10-23.2-14.32-20.07c-6.67,4.84-16.61,13.44-18.34,12.93-2.15-.64-5-5.82-17.52-21C194.41,127.88,190,132.52,192,139.71Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.43,134.8c3.56-1.36,7.54-3.2,11.54-3.22s7.43,5.18,7.47,6.69-1.26,11-5.25,11.06-1.75-7.2-1.92-8-.35-1.88-1.1-1.78-13.79,6.65-13.79,6.65Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.69,135.34c.23,0,10.83-4.47,14.83-4.49S266,136,266,137.53s-1.26,11-5.25,11.06-1.75-7.2-1.92-8-.35-1.89-1.1-1.79-13.79,6.66-13.79,6.66Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.37,148.12a4.88,4.88,0,0,1-.72-2.35,8.39,8.39,0,0,1,.09-2.55,13.92,13.92,0,0,0,.43-2.21,4.44,4.44,0,0,0-.6-2.1c-.32-.55-.91-.35-1.41-.16a22.28,22.28,0,0,0-2.15,1L252.77,141a21.67,21.67,0,0,0-2.29,1.33.06.06,0,0,0,.05.11,21.58,21.58,0,0,0,2-1l2.26-1.1c.71-.33,1.4-.71,2.12-1,.25-.11.75-.4,1-.34s.47.81.55,1.05a3.79,3.79,0,0,1-.09,2.16,11,11,0,0,0-.36,2.2,5.83,5.83,0,0,0,.21,2.08,8.26,8.26,0,0,0,1,1.69C259.3,148.27,259.43,148.18,259.37,148.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.27,146.12s10.83-10.35,13.09-12.4c4.53-4.13,23.81-12.54,26.52-12.89s3.81,5.19-9.27,11.28c-6.89,3.2-8,7.22-7.85,9.43s2.39,6.28,6.1,6.09,6-5.67,9.41-6.35,1.29,5.63-1,9.3a22.75,22.75,0,0,1-9.82,8c-3.19,1.28-13,5.8-13,5.8Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.42,144.91c-1.38,1.12-2.93,2.56-4.77,2.67s-3.17-1.09-4.09-2.62a7.06,7.06,0,0,1-1.1-5.12,8.73,8.73,0,0,1,2.45-4.23,21.38,21.38,0,0,1,5-3.47c.08,0,0-.16-.08-.12-1.69.81-7,3.11-7.91,7.83a7.25,7.25,0,0,0,1.15,5.22c.86,1.46,2.09,2.86,3.9,3,2.2.13,4.05-1.7,5.6-3.07C264.59,144.9,264.49,144.85,264.42,144.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.24,144.71,248.39,170S222.47,185.35,215,183.15s-19.21-23.24-24.27-41.82,6.59-11.7,11.18-6,14.56,18.8,15.09,18.61S231.24,144.71,231.24,144.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.94,174.15c-1.61.86-3.38,1.77-5.24,2.68l-14.95-25.28c1.5-1,3.24-2.1,4.87-3.16C230.33,156.29,236.05,165.9,240.94,174.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.68,177.81l-1.72.79-14.72-24.83c.32-.18.86-.52,1.56-1C223.43,160.57,228.94,169.83,233.68,177.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.09,179.43c-5.93,2.58-11.76,4.49-14.84,3.79l-.27-.07c-7.48-2.2-19.2-23.23-24.27-41.82a29.33,29.33,0,0,1-1.25-7.66c0-.1,0-.18,0-.28s0-.29,0-.44a1.1,1.1,0,0,1,0-.18,2.46,2.46,0,0,1,0-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,167.71c-.54-.9-1.1-1.8-1.65-2.69-1.11-1.79-7.77-12.4-10.38-15.61-.07-.09-.2,0-.16.11,1.86,3.72,8.75,14.13,9.9,15.85.59.87,1.17,1.75,1.77,2.62s1.3,1.68,1.9,2.56c.06.08.2,0,.15-.08C240.07,169.57,239.63,168.61,239.09,167.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3,214.47c.16.17,66.31-7.72,66.89-8.43.82-1-16.09-66.92-23.24-75.62-1.53-1.86-6.38-2.23-10.47-1.58a18.29,18.29,0,0,0-3.14.75l-.1,0a7.51,7.51,0,0,0-2.29,1.21c-11.12,9.51-19.67,41.72-21.59,51.38C156.16,198.12,152.73,213.86,153.3,214.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.83,198.89c-16,2.07-50.71,6.57-64.51,8.22.48-2.45,1.06-5.37,1.72-8.59l60.83-7.61C217.64,193.91,218.31,196.63,218.83,198.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.05,187.66c-15.8,2.05-45,5.82-59.34,7.57l.56-2.74,58.13-7.33C215.62,186,215.84,186.84,216.05,187.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,148.09c3.35,17.25,18.64,49.29,28.18,52.12,11.05,3.27,48.82-9.78,56.16-15.43,2.92-2.24-13.37-21-17-19.6-15.36,6.06-29,9.31-31.05,8-3.12-2-16-19.63-24.42-30.55C177.75,128.91,174.94,140.36,176.45,148.09Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,185.33c1.68-.65,13.14-9.38,16.48-13.43a50.81,50.81,0,0,0,8.64-14.1c3.27-8.14,4.76-14.07,3.87-16.69-1-3.05-1.33-3.54-9.08,10-4.38,7.67-8.71,8.62-12.48,8.63a58,58,0,0,0-26.64,6.62S253.37,187.8,259.82,185.33Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.36,131l-19.54,25.87a2.39,2.39,0,0,1-2.41.85l-14.15-4.34a1,1,0,0,1-.46-1.73l19.54-25.87a2.37,2.37,0,0,1,2.41-.85l14.15,4.34A1,1,0,0,1,294.36,131Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,128.84l-14.15-4.34a2.39,2.39,0,0,0-2.41.86l-19.53,25.87A1,1,0,0,0,257,153l14.15,4.34a2.41,2.41,0,0,0,2.41-.85l19.53-25.87A1,1,0,0,0,292.63,128.84Zm-19.37,26.53a2.23,2.23,0,0,1-2.22.84l-12.65-3.88c-.71-.22-.87-1-.35-1.63l18.19-24.09c1-1.38,1.67-1.28,2.38-1.06l2.53.78c.15,0,.16.23,0,.41l-.06.08c-.33.44-.06.52.27.62l5.86,1.8a.68.68,0,0,0,.92-.25l.06-.08a.54.54,0,0,1,.52-.25l2.54.78c.7.21,1.14.57.18,1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5,128.05l-1.59-.5a.07.07,0,0,1,0-.11h0a.16.16,0,0,1,.17-.06l1.6.49a.07.07,0,0,1,0,.12h0A.18.18,0,0,1,285.5,128.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.19,
    y1: 149.17,
    x2: 259.14,
    y2: 149.16,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.45,131.28l-18.19,24.09a2.23,2.23,0,0,1-2.22.84l-12.65-3.88c-.71-.22-.87-1-.35-1.63l18.19-24.09c1-1.38,1.67-1.28,2.38-1.06l2.53.78c.15,0,.16.23,0,.41l-.06.08c-.33.44-.06.52.27.62l5.86,1.8a.68.68,0,0,0,.92-.25l.06-.08a.54.54,0,0,1,.52-.25l2.54.78C292,129.65,292.41,130,291.45,131.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.45,131.28l-1.36,1.8-15.22-4.67,1.36-1.8c1-1.38,1.67-1.28,2.38-1.06l2.53.78c.15,0,.16.23,0,.41l-.06.08c-.33.44-.06.52.27.62l5.86,1.8a.68.68,0,0,0,.92-.25l.06-.08a.54.54,0,0,1,.52-.25l2.53.78C292,129.65,292.41,130,291.45,131.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.07 128 276.91 127.49 277.64 127.26 277.66 127.34 277.06 127.54 277.19 127.96 277.07 128",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.06,131.34a.13.13,0,0,1-.14,0,.06.06,0,0,1,0-.1.14.14,0,0,1,.14-.06C290.08,131.25,290.1,131.3,290.06,131.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,131.62a.14.14,0,0,1-.15,0,.06.06,0,0,1,0-.1.13.13,0,0,1,.14-.06A.07.07,0,0,1,289.85,131.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.64,131.9a.14.14,0,0,1-.15,0c-.05,0-.06-.06,0-.11a.17.17,0,0,1,.15-.05A.07.07,0,0,1,289.64,131.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.3,126.74h-.07a.22.22,0,0,0-.17-.16.52.52,0,0,0-.3,0h0v0h0l.05,0,.1,0h.17s0,0,0,0h0l.07,0,0,0,0,.06v0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.79,126.71v0a.38.38,0,0,1,.21,0,.19.19,0,0,1,.18.14l-.06,0a.18.18,0,0,0-.12-.1A.28.28,0,0,0,279.79,126.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,126.83l-.06,0a.09.09,0,0,0-.06-.06.22.22,0,0,0-.11,0v0C279.91,126.71,280,126.74,280,126.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.91,126.86s0,0-.06,0,0,0,0,0l.05,0S279.92,126.85,279.91,126.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.86,126.07A.16.16,0,0,1,278,126a.07.07,0,0,1,0,.12.16.16,0,0,1-.17.06A.07.07,0,0,1,277.86,126.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.18,126.17a.16.16,0,0,1,.17-.06.07.07,0,0,1,0,.12.18.18,0,0,1-.17.06A.07.07,0,0,1,278.18,126.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5,126.26a.14.14,0,0,1,.16-.05c.06,0,.07.07,0,.12a.16.16,0,0,1-.17,0C278.47,126.37,278.46,126.31,278.5,126.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.81,126.36a.19.19,0,0,1,.17-.06.07.07,0,0,1,0,.12.17.17,0,0,1-.17.06A.07.07,0,0,1,278.81,126.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,126.46a.16.16,0,0,1,.17-.06c.06,0,.07.07,0,.12a.16.16,0,0,1-.17.06A.07.07,0,0,1,279.13,126.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.89 130.55 289.6 130.15 290.15 129.43 291.44 129.82 290.89 130.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.79 129.93 290.26 129.77 290.09 129.99 290.62 130.16 290.79 129.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.93 130.22 290.86 130.2 291 130.02 291.07 130.04 290.93 130.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.53 151.17 260.42 151.13 260.06 151.61 259.84 151.54 260.02 151.3 259.64 151.18 259.46 151.42 259.24 151.36 259.6 150.88 259.48 150.85 260.37 150.53 260.53 151.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.42 154.42 271.15 154.03 271.27 153.88 272.54 154.26 272.42 154.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.12 154.82 270.86 154.43 270.98 154.27 272.24 154.66 272.12 154.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.82 155.22 270.56 154.83 270.68 154.67 271.94 155.06 271.82 155.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.24 152.84 265.62 153.07 265.52 152.62 265.62 152.58 265.71 152.96 266.21 152.76 266.24 152.84",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,153.91a1.14,1.14,0,0,1-.37,0,1,1,0,0,1-.64-.6,1,1,0,0,1,.19-.91,1.52,1.52,0,0,1,1.56-.53.93.93,0,0,1,.63.6,1,1,0,0,1-.18.91h0A1.53,1.53,0,0,1,265.61,153.91Zm.35-1.14a.58.58,0,0,0-.33.14A.61.61,0,0,0,266,152.77Zm.07-.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,129.2a.7.7,0,0,1,.68-.24.3.3,0,0,1,.2.16s0,.07-.05.08-.08,0-.09,0a.2.2,0,0,0-.14-.11.39.39,0,0,0-.26,0,.52.52,0,0,0-.21.14.23.23,0,0,0-.05.2.23.23,0,0,0,.15.14.41.41,0,0,0,.22,0s.08,0,.08,0a.08.08,0,0,1-.07.07.58.58,0,0,1-.32,0A.29.29,0,0,1,282,129.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.62,129.77l.44-.58a.12.12,0,0,1,.11,0,.05.05,0,0,1,0,.08l-.18.23.29.09.18-.24a.1.1,0,0,1,.1,0s.05,0,0,.07l-.44.59a.1.1,0,0,1-.1,0s-.05,0,0-.08l.18-.24-.29-.09-.18.24a.12.12,0,0,1-.11,0S282.6,129.81,282.62,129.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,130l-.28-.08-.15.11a.08.08,0,0,1-.08,0h0s0-.06,0-.09l.69-.51a.1.1,0,0,1,.09,0s0,0,0,.05l-.19.66a.1.1,0,0,1-.09.06h0s0,0,0-.05Zm0-.12.07-.25-.25.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.83,129.8l-.17-.06-.4.54a.11.11,0,0,1-.11,0,0,0,0,0,1,0-.07l.4-.53-.17-.06s-.05,0,0-.07a.1.1,0,0,1,.1,0l.48.15a0,0,0,0,1,0,.07A.11.11,0,0,1,284.83,129.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.94 138.98 279.82 142.32 282.12 139.28 271.23 135.94 271.23 135.94 268.94 138.98 268.94 138.98",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.83 142.63 279.82 142.32 280.53 141.38 280.83 142.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.06 139.67 271.42 136.71 271.46 136.66 281.1 139.61 281.06 139.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.82 139.37 271.18 137.03 271.22 136.97 278.86 139.31 278.82 139.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.56 140.36 270.71 137.65 270.75 137.59 279.6 140.31 279.56 140.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 140.92 270.48 137.96 270.52 137.9 280.16 140.86 280.11 140.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.88 141.23 270.24 138.27 270.28 138.21 279.92 141.17 279.88 141.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.97 140.72 270 138.58 270.05 138.53 277.02 140.66 276.97 140.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.52 146.15 274.41 149.49 276.7 146.45 265.82 143.11 265.82 143.11 263.52 146.15 263.52 146.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.42 149.8 274.41 149.49 275.11 148.56 275.42 149.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.64 146.84 266 143.88 266.04 143.83 275.68 146.78 275.64 146.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.4 146.54 265.76 144.2 265.81 144.14 273.45 146.48 273.4 146.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.14 147.53 265.3 144.82 265.34 144.76 274.18 147.48 274.14 147.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.7 148.09 265.06 145.13 265.1 145.07 274.74 148.03 274.7 148.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.46 148.4 264.82 145.44 264.87 145.38 274.51 148.34 274.46 148.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.56 147.89 264.59 145.75 264.63 145.7 271.6 147.84 271.56 147.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.4 136.58 274.52 133.24 276.45 130.67 287.34 134.01 285.4 136.58",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.51 132.93 274.52 133.24 275.22 132.3 273.51 132.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.71 133.86 276.69 131.4 276.73 131.34 284.76 133.81 284.71 133.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.09 134.67 276.45 131.71 276.5 131.65 286.13 134.61 286.09 134.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.85 134.98 276.22 132.02 276.26 131.97 285.9 134.92 285.85 134.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.86 135.06 275.98 132.34 276.02 132.28 284.9 135 284.86 135.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.38 135.6 275.75 132.65 275.79 132.59 285.43 135.55 285.38 135.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.63 135.14 275.51 132.96 275.55 132.9 282.68 135.09 282.63 135.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.65 138.89 272.77 135.55 274.2 133.65 285.09 136.99 283.65 138.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.76 135.24 272.77 135.55 273.47 134.62 271.76 135.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.06 137.33 274.44 134.38 274.48 134.32 284.1 137.27 284.06 137.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.12 137.12 274.2 134.69 274.25 134.63 282.17 137.06 282.12 137.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.68 137.67 273.97 135 274.01 134.94 282.73 137.62 282.68 137.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.45 137.37 273.73 135.31 273.78 135.25 280.5 137.32 280.45 137.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.25 146.05 267.36 142.71 269.39 140.03 280.27 143.37 278.25 146.05",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.36 142.4 267.36 142.71 268.07 141.77 266.36 142.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.02 144.47 268.92 141.68 268.97 141.62 278.07 144.42 278.02 144.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.05 144.56 268.69 141.99 268.73 141.93 277.09 144.5 277.05 144.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.97 143.69 269.39 141.06 269.44 141 278.01 143.63 277.97 143.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.15 143.67 269.63 140.75 269.67 140.69 279.19 143.61 279.15 143.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.11 144.96 268.45 142.3 268.5 142.25 277.15 144.9 277.11 144.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.14 152.82 262.25 149.48 263.94 147.25 274.82 150.59 273.14 152.82",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.24 149.17 262.25 149.48 262.95 148.54 261.24 149.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.82 150.91 264.19 147.95 264.23 147.9 273.87 150.85 273.82 150.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.59 151.22 263.95 148.26 263.99 148.21 273.63 151.16 273.59 151.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.59 151.3 263.71 148.58 263.76 148.52 272.63 151.24 272.59 151.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.12 151.84 263.48 148.89 263.52 148.83 273.16 151.79 273.12 151.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.37 151.38 263.24 149.2 263.29 149.14 270.41 151.33 270.37 151.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,159.66c-3.89.15,8.58-8,8.67-12.49s-4.2-2.94-7.55-.36c-11.61,9-20.54,8.75-26.34,17.19S269.13,159.66,269.13,159.66Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23,154.53a30.91,30.91,0,0,0-7.22,3,19,19,0,0,0-5.15,5c-.06.09.06.2.13.11,3.1-4,7.78-6.07,12.27-8.07A.06.06,0,0,0,257.23,154.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,172.09c3.05.75,24-5.52,24-5.52L250,195s-36.54,9.4-45.18,6.63S182.18,170,177.47,153.17c-4.43-15.82.74-26.33,12.49-10.11C190,143.06,211.91,171.7,213.5,172.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,196.58c-2.36.54-5.18,1.18-8.23,1.83l-11.45-28c2.74-.67,5.61-1.45,8-2.12C235.21,176.79,239.49,187.16,243.36,196.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93,199.06l-2.65.53-11.42-27.91c.8-.15,1.67-.33,2.57-.53C223.89,179.51,228.1,189.71,231.93,199.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,200.72c-7.27-3.51-16.58-22.56-18.37-26.3-1.15-2.39-2.2-4.83-3.24-7.27-2.07-4.9-4-9.85-5.83-14.83a.07.07,0,1,0-.13,0q1.55,5.79,3.67,11.42a41.73,41.73,0,0,1-2.45-4.32c0-.07-.16,0-.13.06a24,24,0,0,0,2.85,5c1.44,3.77,3.05,7.47,4.83,11.07.51,1,11.31,24.39,19.39,26.39,2.81.7,12.35-.21,14.37-.72.08,0,.1-.13,0-.13C216.59,201.13,207,202,204.38,200.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,191.67c-.38-1-.76-2-1.15-2.94-.78-1.95-5.48-13.57-7.48-17.19,0-.1-.2,0-.17.08,1.17,4,6.13,15.45,7,17.34.42,1,.84,1.93,1.28,2.89s1,1.89,1.42,2.86c0,.09.2,0,.16-.06C242.66,193.68,242.4,192.65,242,191.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.52,166.61c-1.75.12-17.45,4.16-20.92,5a7.07,7.07,0,0,1-2.57.42,3.73,3.73,0,0,1-2.1-1.5c-1.16-1.27-13.89-17.3-14.81-18.08-.34-.3-.61-.35-.28.16.57.87,12.95,16.7,14.07,18s2,2.37,3.73,2.26c.74-.05,21.93-5.32,23-5.78C237.82,167,237.79,166.59,237.52,166.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,139.92c-3.16.58-11.23-3.13-13.23-7.7-.14-.32.6-3.42,1.32-7.24.42-2.32.84-4.92,1-7.31,0-.49,14.69,5,14.69,5a38.23,38.23,0,0,0-2.26,9.07,4.64,4.64,0,0,0,0,1,.85.85,0,0,1,0,.16C197.75,134.76,199.4,139.29,196,139.92Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.61,132.7v.16a10.27,10.27,0,0,1-1.54-.05c-8.82-1-10.18-12.25-10.38-15.09,2.64.62,14.16,4.92,14.16,4.92a38.23,38.23,0,0,0-2.26,9.07A5.38,5.38,0,0,0,197.61,132.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,102c-.55,5.56,5.24,20.14,9.65,22.77,6.38,3.82,15.32,2.51,18.17-4.81,2.77-7.1-5.11-26-9.89-28.21C190,88.45,179.89,93.78,179.08,102Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,108.1s-.06.08,0,.11c.41,1,.73,2.16,0,2.84a0,0,0,0,0,0,0C196.64,110.52,196.21,109,195.66,108.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,107.41c-1.63.5-.51,3.73,1,3.26S195.74,107,194.38,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.49,106.25s.1,0,.11.06c.32,1,.85,2.12,1.87,2.14,0,0,0,0,0,0C202.32,108.73,201.63,107.26,201.49,106.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,104.9c1.57-.68,2.81,2.5,1.36,3.13S200.71,105.47,202,104.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,106.38a13.13,13.13,0,0,0,1.1-.87,2.31,2.31,0,0,0,.95-1.1.74.74,0,0,0-.4-.79,1.78,1.78,0,0,0-1.76.42,2.6,2.6,0,0,0-1.06,1.57A.76.76,0,0,0,192.59,106.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.71,102.85c-.48.08-.92.07-1.4.11a2.32,2.32,0,0,1-1.45-.16.72.72,0,0,1-.25-.84,1.81,1.81,0,0,1,1.58-.91,2.66,2.66,0,0,1,1.84.43A.77.77,0,0,1,202.71,102.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,117.69A1.59,1.59,0,0,0,199,118a2.72,2.72,0,0,0,1-.62,0,0,0,0,1,.06,0,1.37,1.37,0,0,1-1.07,1,1.13,1.13,0,0,1-1.1-.61C197.84,117.71,197.91,117.66,198,117.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,114.33a3.62,3.62,0,0,0,2.79.73,4.54,4.54,0,0,0,1.24-.37l.23-.11.2-.11a.28.28,0,0,0,.13-.29h0a.3.3,0,0,0,0-.1h0l0-.08c-.24-.78-.72-1.92-.72-1.92.33,0,2,.19,1.82-.21a54.58,54.58,0,0,0-4.89-9.83c-.06-.1-.22,0-.18.09,1.18,3.18,2.91,6.13,4.14,9.31a6.37,6.37,0,0,0-1.77.07c-.1.07,1,2.19,1,2.55a.1.1,0,0,1,0,0,5,5,0,0,1-3.9.13C197.93,114.18,197.88,114.27,198,114.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,114.46a4.27,4.27,0,0,1-1.18,1.81,1.92,1.92,0,0,1-1.08.45c-.87.07-1.14-.66-1.21-1.33a4.82,4.82,0,0,1,0-1.09A5.53,5.53,0,0,0,201.41,114.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.23,116.27a1.92,1.92,0,0,1-1.08.45c-.87.07-1.14-.66-1.21-1.33A2,2,0,0,1,200.23,116.27Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,115.49c2.86-1.18-.75-9.1-.75-9.1a6.93,6.93,0,0,0,3.83-6.34s12.27-1,14-5.78-1.66-10.89-3.17-10.81-3,2.7-3,2.7-1.59-1.94-2.83-1.8c-1.91.21-2.21,2.75-3,3.58-2.16,2.17-9.6,4.57-11.21,6.7a4.24,4.24,0,0,0-.91,3.9,4.9,4.9,0,0,0-2.21,4.06C174.65,106.21,181.26,116.69,184.14,115.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.39,114.8c2.09-3,.06-7.09-1.92-9.66,0,0,0-.08.07,0,2,2.35,4.38,7,2,9.8A.08.08,0,0,1,184.39,114.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.22,99.61a28.49,28.49,0,0,0,8.45-.15,17.09,17.09,0,0,0,3.68-1.22c1.17-.54,3.25-1.47,3.71-2.8,0,0,0,0,0,0a4.77,4.77,0,0,1-2.34,2.39,15.47,15.47,0,0,1-4.36,1.83,19.82,19.82,0,0,1-9.22.18C185,99.82,185.07,99.6,185.22,99.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21,92.81a36.25,36.25,0,0,1,4.23-2.11c1.78-.87,3.94-1.72,5.35-3.14a0,0,0,1,1,.05,0A11.79,11.79,0,0,1,185.4,90c-1.26.69-2.55,1.33-3.85,1.94-1.48.7-3.11,1.5-4,3s-.59,3-.4,4.51a.13.13,0,0,1-.25.05A5.69,5.69,0,0,1,179.21,92.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.42,99.26a0,0,0,0,1,0,0c-3.14,2.28-1.54,6.92.07,9.65a14.22,14.22,0,0,0,6.35,6.16c.13.05,0,.25-.1.2-3.26-1.28-5.66-4.4-7.16-7.46C174.46,105.5,173.2,100.63,176.42,99.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,113.73s-4.49-4.12-6.43-2.41,2.18,8.2,5,8.59a2.71,2.71,0,0,0,3.23-2.2Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,113.15s0,.07,0,.07c2,.34,3.32,1.81,4.37,3.42a1.48,1.48,0,0,0-2.26.08s0,.11.07.09a1.64,1.64,0,0,1,1.91.17,7.71,7.71,0,0,1,1.17,1.25c.13.15.4,0,.3-.18l0,0C185.28,115.68,182.75,112.83,180.21,113.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68,132.32a0,0,0,0,0-.05,0c1,2.88,3.12,9.6-1.42,10.41a9.74,9.74,0,0,1-5.46-1.14,26.61,26.61,0,0,1-4.86-2.91,39.47,39.47,0,0,1-4.92-4.1c-.07-.07-.15,0-.09.1,1.55,1.5,3,3.12,4.64,4.47a22.82,22.82,0,0,0,5.28,3.25,9.7,9.7,0,0,0,5.74,1,3.7,3.7,0,0,0,2.85-3.79A17.68,17.68,0,0,0,198.68,132.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-154"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.46,
    y: 374.36,
    width: 162.64,
    height: 68.27,
    transform: "translate(741.56 816.99) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,374.36s2.24-10.05,6.71-11.59,7.2,3,7.2,3,1.05-9.6,7.39-12.47,11.11,3,11.11,3,4.87-12.18,13.56-12.18,13.08,17.82,13.08,17.82,5.14-5.31,10.4-2.31,5.26,14.76,5.26,14.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,374.36H449s-2.22-9.13-6.69-9.78-6.55,3.59-6.55,3.59.2-12.73-8.14-14.9-15.34,9.08-15.34,9.08-5.24-6.41-12.37-6-8.94,11-8.94,11S384.51,363.68,381.65,374.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42,374.36h41.4s-.1-5.92-4.17-7.49a5.67,5.67,0,0,0-6.49,1.49s-1.66-10.89-9.24-10.89-11.22,9.4-11.22,9.4a5.86,5.86,0,0,0-5.9-2.31C362.59,365.08,362.42,374.36,362.42,374.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 434.39,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 876.83) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 424.38,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 856.82) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 414.38,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 836.81) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 404.37,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 816.8) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 394.37,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 796.79) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 384.36,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 776.78) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.78,
    y: 374.36,
    width: 135.99,
    height: 8.06,
    transform: "translate(779.55 756.77) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 434.39,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 876.83) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 434.39,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 876.83) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 424.38,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 856.82) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 424.38,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 856.82) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 414.38,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 836.81) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 414.38,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 836.81) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 404.37,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 816.8) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 404.37,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 816.8) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 394.37,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 796.79) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 394.37,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 796.79) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 384.36,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 776.78) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 384.36,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 776.78) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 374.36,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 756.77) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.79,
    y: 374.36,
    width: 37.99,
    height: 8.06,
    transform: "translate(605.57 756.77) rotate(180)",
    style: {
      fill: "#020100",
      opacity: 0.2
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtChat3);
export default __webpack_public_path__ + "static/media/art__chat__3.b98d77486f11748f0416f4222bced214.svg";
export { ForwardRef as ReactComponent };